import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AiSearchResponseView } from "./AiSearchResponseView";
import { AiSearchResponseViewStore } from "../../store/AiSearchResponseViewStore";
import { useStore } from "../../../../hooks";

export const AiSearchResponseViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/aiSearchResponse/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AiSearchResponseViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AiSearchResponseView aiSearchResponseViewStore={store} />
      </PageLayout>
    </div>
  );
});
